import React from 'react';
import { motion } from 'framer-motion';
import { Laptop, SprayCan as Spray, Home } from 'lucide-react';
import { SparkleDivider } from '../SparkleDivider';
export function HowItWorks() {
  const steps = [{
    num: '1',
    icon: Laptop,
    title: 'Book Online',
    desc: 'Pick your service, choose your date, and book in minutes. No phone tag required.'
  }, {
    num: '2',
    icon: Spray,
    title: 'We Show Up & Shine',
    desc: 'Our vetted team arrives on time with everything needed to make your space spotless.'
  }, {
    num: '3',
    icon: Home,
    title: 'Come Home to Heaven',
    desc: 'Walk in and feel the difference. Fresh, clean, and ready for life.'
  }];
  return <section className="py-24 bg-white" data-id="element-171">
      <div className="container mx-auto px-4" data-id="element-172">
        <SparkleDivider className="mb-12" data-id="element-173" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-174">
          <h2 className="font-serif text-4xl md:text-5xl text-brand-charcoal mb-4" data-id="element-175">
            Cleaning, Made Heavenly Simple
          </h2>
          <p className="text-xl text-brand-charcoal/70 font-light" data-id="element-176">
            Three easy steps to a spotlessly blessed home.
          </p>
        </motion.div>

        <div className="relative max-w-5xl mx-auto" data-id="element-177">
          {/* Connector line - desktop only */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 border-t-2 border-dashed border-brand-gold/30 -z-10" data-id="element-178" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-179">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2,
            duration: 0.6
          }} className="flex flex-col items-center text-center relative" data-id="element-180">
                <div className="w-24 h-24 rounded-full bg-brand-white border-4 border-white shadow-soft flex items-center justify-center relative mb-8" data-id="element-181">
                  <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-brand-gold text-white font-serif font-bold flex items-center justify-center shadow-sm" data-id="element-182">
                    {step.num}
                  </div>
                  <step.icon className="w-10 h-10 text-brand-blue" data-id="element-183" />
                </div>

                <h3 className="font-serif text-2xl text-brand-charcoal mb-4" data-id="element-184">
                  {step.title}
                </h3>
                <p className="text-brand-charcoal/70 leading-relaxed max-w-sm" data-id="element-185">
                  {step.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}